'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestUnprotectedRoute = exports.request = undefined;

var request = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(method, url, data, responseType) {
        var authToken, apiUrl, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        authToken = localStorage.getItem('authToken');
                        apiUrl = '/api' + url;
                        _context.prev = 2;
                        _context.next = 5;
                        return (0, _axios2.default)({
                            method: method,
                            responseType: responseType ? responseType : 'json',
                            url: apiUrl,
                            params: method === 'get' ? data : undefined,
                            data: method !== 'get' ? data : undefined,
                            headers: {
                                'Authorization': 'Bearer ' + authToken
                            }
                        });

                    case 5:
                        response = _context.sent;
                        return _context.abrupt('return', response);

                    case 9:
                        _context.prev = 9;
                        _context.t0 = _context['catch'](2);
                        throw _context.t0;

                    case 12:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[2, 9]]);
    }));

    return function request(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
    };
}();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function requestUnprotectedRoute(method, url, data) {

    var apiUrl = '/api' + url;

    return (0, _axios2.default)({
        method: method,
        url: apiUrl,
        data: data
    });
}

exports.request = request;
exports.requestUnprotectedRoute = requestUnprotectedRoute;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/api/index.js
// module id = 33
// module chunks = 0